"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminFolderFromJSON = AdminFolderFromJSON;
exports.AdminFolderFromJSONTyped = AdminFolderFromJSONTyped;
exports.AdminFolderToJSON = AdminFolderToJSON;
exports.AdminFolderToJSONTyped = AdminFolderToJSONTyped;
function AdminFolderFromJSON(json) {
    return AdminFolderFromJSONTyped(json, false);
}
function AdminFolderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'parentFolderId': json['parentFolderId'],
        'folderType': json['folderType'],
        'label': json['label'],
        'childCount': json['childCount'],
    };
}
function AdminFolderToJSON(value) {
    return AdminFolderToJSONTyped(value, false);
}
function AdminFolderToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'parentFolderId': value.parentFolderId,
        'folderType': value.folderType,
        'label': value.label,
        'childCount': value.childCount,
    };
}
